var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    style: {
      "--color": _vm.themeColor
    }
  }, [_c("div", {
    staticClass: "title-box",
    style: _vm.background ? " padding: 0 10px;padding-top:15px" : "background: #eee;"
  }, [_c("div", {
    staticClass: "leftBox"
  }, [_c("span", {
    staticClass: "title"
  }, [_vm._t("title")], 2), _c("div", [_vm._t("handle")], 2)]), _c("div", [_vm._t("btn")], 2)]), _vm._t("des")], 2);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };